import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

// Register a new startup
export const registerStartup = async (startupData) => {
  try {
    const token = localStorage.getItem('token');
    // Don't set Content-Type manually — axios sets it automatically for
    // FormData with the correct multipart boundary.
    const config = {
      headers: {
        'x-auth-token': token,
      },
    };
    const response = await axios.post(`${API_URL}/api/startups`, startupData, config);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get startup profile
export const getStartupProfile = async (startupId) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        'x-auth-token': token,
      },
    };
    const response = await axios.get(`${API_URL}/api/startup/${startupId}`, config);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Update startup profile
export const updateStartupProfile = async (startupId, startupData) => {
  try {
    const token = localStorage.getItem('token');
    // Don't set Content-Type manually — axios sets it automatically,
    // correctly, for both FormData (multipart with boundary) and plain
    // objects (application/json).
    const config = {
      headers: {
        'x-auth-token': token,
      },
    };
    const response = await axios.put(`${API_URL}/api/startup/${startupId}`, startupData, config);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export default {
  registerStartup,
  getStartupProfile,
  updateStartupProfile,
};
